import styled from "styled-components";

const Frame = styled.div`
  width: 700px;
  height: 466px;
  border: 50px solid rgba(226,192,180,0.8);
  overflow: hidden;
  position: relative;
`;

export default Frame;